import { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../_metronic/layout/core'
import { KTIcon, toAbsoluteUrl } from '../../_metronic/helpers'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
} from '../../_metronic/partials/widgets'


const HomePage: FC = () => (
  <>

    <div className='row gy-6 gx-xl-8'>
      <div className='col-xxl-9'>
        <div className='card mb-10'>
          <div className='card-body d-flex align-items-center py-8'>
            <div className='d-flex h-80px w-80px flex-shrink-0 flex-center position-relative'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                className='text-primary h-75px w-75px h-lg-100px w-lg-100px position-absolute opacity-5'
              >
                <path
                  fill='currentColor'
                  d='M10.2,21.23,4.91,18.17a3.58,3.58,0,0,1-1.8-3.11V8.94a3.58,3.58,0,0,1,1.8-3.11L10.2,2.77a3.62,3.62,0,0,1,3.6,0l5.29,3.06a3.58,3.58,0,0,1,1.8,3.11v6.12a3.58,3.58,0,0,1-1.8,3.11L13.8,21.23A3.62,3.62,0,0,1,10.2,21.23Z'
                ></path>
              </svg>
              <KTIcon iconName='wrench' className='fs-2x fs-lg-3x text-primary position-absolute' />
            </div>

            <div className='ms-6 ,-2'>
              <p className='list-unstyled text-gray-800 fw-bold fs-4 p-0 m-2'>
                피치톡 다운로드
              </p>
              <p className='list-unstyled text-gray-600 fs-6 p-0 m-2'>
                메시지 전송을 위해서는 피치톡이 설치 및 실행되어 있어야 합니다.
              </p>

              <a href="javascript:alert('메뉴얼 준비중')" className="btn btn-flex btn-warning px-6 m-2">
                <span className="svg-icon svg-icon-2x"><i className="bi bi-filetype-pdf px-6 fs-1"></i></span>
                <span className="d-flex flex-column align-items-start ms-2">
                  <span className="fs-3 fw-">메뉴얼</span>
                  <span className="fs-7">다운로드</span>
                </span>
              </a>

              <a href="/sw/PeachTalk_v1.0.0.zip" target='_blank' className="btn btn-flex btn-success px-6">
                <span className="svg-icon svg-icon-2x"><i className="bi bi-download px-6 fs-1"></i></span>
                <span className="d-flex flex-column align-items-start ms-2">
                  <span className="fs-3 fw-">피치톡</span>
                  <span className="fs-7">다운로드</span>
                </span>
              </a>

            </div>
          </div>
        </div>
      </div>


      <div className='col-xl-3'>
      <div className='card mb-10'>
          <div className='card-body d-flex align-items-center py-8'>
            
            <div className='ms-6 ,-2'>
              <p className='list-unstyled text-gray-800 fw-bold fs-4 p-0 m-2'>
                운용환경
              </p>

              <div className='m-14'>
                <span className="fs-4"><i className="bi bi-windows fs-2 m-2"></i> Window PC</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>




    {/* <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div> */}



{/* 

    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget20
          className='h-md-50 mb-5 mb-xl-10'
          description='Active Projects'
          color='#F1416C'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />
        <CardsWidget7
          className='h-md-50 mb-5 mb-xl-10'
          description='Professionals'
          icon={false}
          stats={357}
          labelColor='dark'
          textColor='gray-300'
        />
      </div>
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' />
        <ListsWidget26 className='h-lg-50' />
      </div>
      
      <div className='col-xxl-6'>
        <EngageWidget10 className='h-md-100' />
      </div>      
    </div>
    <div className='row gx-5 gx-xl-10'>
      <div className='col-xxl-6 mb-5 mb-xl-10'>
      </div>
      <div className='col-xxl-6 mb-5 mb-xl-10'>
      </div>
    </div>
    <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div>
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        </div>
    </div>
    
    <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div> */}
  </>
)


const Home: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{'피치톡'}</PageTitle>
      <HomePage />
    </>
  )
}

export { Home }
